<template>
  <div class="product-card">
    <router-link :to="`/product/${slug}`" class="card-img-link">
      <div class="card-img-wrap">
        <img
          :src="img"
          :alt="name"
          loading="lazy"
          @mouseenter="swapImg($event)"
          @mouseleave="restoreImg($event)"
        />
        <span v-if="isOnSale" class="badge-sale">SALE</span>
      </div>
    </router-link>
    <div class="card-body">
      <router-link :to="`/product/${slug}`" class="card-name">{{ name }}</router-link>
      <div class="card-price-row">
        <template v-if="isOnSale">
          <span class="price-sale">{{ salePrice }} {{ currSymbol }}</span>
          <span class="price-original">{{ regularPrice }} {{ currSymbol }}</span>
        </template>
        <template v-else>
          <span class="price-regular">{{ regularPrice }} {{ currSymbol }}</span>
        </template>
      </div>
      <button v-if="!product || !product.variants || product.variants.length === 0" class="btn-add" @click="$emit('add-to-cart', product)">
        {{ t.product_card?.add_to_cart }}
      </button>
      <router-link v-else :to="`/product/${slug}`" class="btn-add btn-select">Wybierz wariant →</router-link>
    </div>
  </div>
</template>

<script>
import { translations } from '@/locales/lang'
import { currentCurrency } from '@/composables/currency'

const CURRENCY_SYMBOLS = {
  PLN:'zł', EUR:'€', USD:'$', CZK:'Kč',
  HUF:'Ft', BGN:'лв', RON:'lei', DKK:'kr.', SEK:'kr'
}

export default {
  name: 'AppProductCard',
  props: {
    product: { type: Object, default: () => ({}) },
    id:      { type: [Number,String] },
    slug:    { type: String },
    name:    { type: String },
    img:     { type: String },
  },
  emits: ['add-to-cart'],
  methods: {
    swapImg(e) {
      const imgs = this.product && this.product.images
      if (imgs && imgs[0] && imgs[0].image_url) {
        e.target._orig = e.target.src
        e.target.style.transition = 'opacity 0.3s'
        e.target.style.opacity = '0'
        setTimeout(() => { e.target.src = imgs[0].image_url; e.target.style.opacity = '1' }, 150)
      }
    },
    restoreImg(e) {
      if (e.target._orig) {
        e.target.style.transition = 'opacity 0.3s'
        e.target.style.opacity = '0'
        setTimeout(() => { e.target.src = e.target._orig; e.target.style.opacity = '1' }, 150)
      }
    }
  },
  computed: {
    t()          { return translations.value },
    curr()       { return currentCurrency.value || 'PLN' },
    currSymbol() { return CURRENCY_SYMBOLS[this.curr] || this.curr },
    priceKey()   { return `price_${this.curr.toLowerCase()}` },
    saleKey()    { return `sale_price_${this.curr.toLowerCase()}` },
    src()        { return this.product },
    regularPrice() {
      const v = Number(this.src?.[this.priceKey] || this.src?.price || 0)
      return isNaN(v) ? '0.00' : v.toFixed(2)
    },
    salePrice() {
      const v = Number(this.src?.[this.saleKey])
      return (!isNaN(v) && v > 0) ? v.toFixed(2) : null
    },
    isOnSale() { return !!this.salePrice },
  }
}
</script>

<style scoped>
.product-card {
  border: 1px solid #f0f0f0; border-radius: 14px;
  overflow: hidden; background: #fff;
  transition: box-shadow .15s, transform .15s;
  display: flex; flex-direction: column;
}
.product-card:hover { box-shadow: 0 8px 24px rgba(0,0,0,.07); transform: translateY(-2px); }
.card-img-wrap {
  position: relative; aspect-ratio: 1/1;
  background: #fafafa; overflow: hidden;
}
.card-img-wrap img { width: 100%; height: 100%; object-fit: cover; }
.badge-sale {
  position: absolute; top: 10px; left: 10px;
  background: #e63946; color: #fff;
  font-size: .7rem; font-weight: 800;
  padding: 3px 10px; border-radius: 9999px;
  letter-spacing: .06em;
}
.card-body { padding: 14px; display: flex; flex-direction: column; gap: 8px; }
.card-name {
  font-size: .92rem; font-weight: 700; line-height: 1.3;
  text-decoration: none; color: inherit;
}
.card-name:hover { color: #b07d4a; }
.card-price-row { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.price-regular { font-size: 1rem; font-weight: 800; color: #111; }
.price-sale     { font-size: 1rem; font-weight: 800; color: #e63946; }
.price-original {
  font-size: .85rem; font-weight: 500;
  color: #999; text-decoration: line-through;
}
.btn-add {
  margin-top: 4px; padding: 9px 16px;
  background: #111; color: #fff;
  border: none; border-radius: 8px;
  font-size: .85rem; font-weight: 700;
  cursor: pointer; transition: background .15s;
}
.btn-add:hover { background: #333; }
.btn-select { display:flex; align-items:center; justify-content:center; text-decoration:none; background:#f5f5f5; color:#111; }
.btn-select:hover { background:#e8e8e8; }
</style>
